import React from "react";

const BlueTickTableTurner = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-[15.83px] h-[15.83px] lg:w-[24px] lg:h-[24px]"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        fill="#5E44FF"
        d="M21.375 5.268h-1.638a.746.746 0 0 0-.588.286l-9.663 12.24-4.634-5.87a.75.75 0 0 0-.588-.286H2.625a.187.187 0 0 0-.147.302l6.42 8.133c.3.38.876.38 1.178 0L21.523 5.568c.096-.12.01-.3-.148-.3Z"
      />
    </svg>
  );
};

export default BlueTickTableTurner;
